<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >Invitación a cotizar</span
            >
            <button
                style="float: right"
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <h2>
            Contratistas a invitar

            <span class="badge accent">{{ data.contratistas.length }}</span>
        </h2>
        <mat-divider></mat-divider>
        <table class="simple mt-8">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Contratista</th>

                    <th>Evaluación</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    *ngFor="
                        let contratista of data.contratistas;
                        let idx = index
                    "
                >
                    <td>
                        <strong>{{ idx + 1 }}.- </strong>
                    </td>
                    <td>
                        <strong
                            >{{ contratista.nombres }}
                            {{ contratista.apellidos }}
                        </strong>
                        <br />
                        <small> {{ contratista.rut }}</small>
                    </td>
                    <td>
                        <app-star-rating
                            [seteable]="false"
                            [evaluacion]="contratista.evaluacion"
                            [cantidadEstrellas]="
                                config.rating.cantidadEstrellas
                            "
                        ></app-star-rating>
                    </td>
                </tr>
            </tbody>
        </table>

        <h2>Datos de la invitación</h2>
        <mat-divider></mat-divider>

        <form class="form mt-8" [formGroup]="formInvitacion" autocomplete="off">
            <div
                fxLayout="row"
                fxLayout.lt-md="column"
                fxLayoutAlign="center center"
                fxLayoutGap.xs="0"
            >
                <div fxFlex="50%" fxFlex.lt-md="100%" fxLayoutAlign="center">
                    <mat-form-field class="width-80">
                        <mat-label>Fecha plazo envio cotización </mat-label>

                        <input
                            matInput
                            [matDatepicker]="fechaVigenciaDatePicker"
                            name="fechaVigencia"
                            formControlName="fechaVigencia"
                            readonly
                            required
                        />
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="fechaVigenciaDatePicker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker
                            #fechaVigenciaDatePicker
                        ></mat-datepicker>
                        <mat-error *ngIf="fechaVigencia.hasError('required')">
                            Debe ingresar la fecha del plazo
                        </mat-error>
                    </mat-form-field>
                </div>
                <div fxFlex="50%" fxFlex.lt-md="100%" fxLayoutAlign="center">
                    <mat-form-field class="width-80">
                        <mat-label>Hora plazo envio cotización</mat-label>

                        <input
                            type="time"
                            matInput
                            name="horaVigencia"
                            formControlName="horaVigencia"
                            required
                            placeholder="HH:MM"
                        />
                        <mat-hint>Entre 00:00 y 23:59 hrs.</mat-hint>

                        <mat-error *ngIf="horaVigencia.hasError('required')">
                            Debe ingresar la hora del plazo
                        </mat-error>
                        <mat-error *ngIf="horaVigencia.hasError('pattern')">
                            El formato de la hora es inválida
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div
                fxLayout="row"
                fxLayout.lt-md="column"
                fxLayoutAlign="center center"
                fxLayoutGap.xs="0"
            >
                <div fxFlex="50%" fxFlex.lt-md="100%" fxLayoutAlign="center">
                    <mat-form-field class="full-width">
                        <mat-label>Comentarios</mat-label>
                        <textarea
                            matInput
                            formControlName="comentario"
                            rows="3"
                            placeholder="Ingrese algún comentario"
                        ></textarea>
                        <mat-hint
                            >{{ comentario.value?.length }} /
                            {{ largoMaximo }}</mat-hint
                        >

                        <mat-error *ngIf="comentario.hasError('maxlength')">
                            Máximo
                            {{
                                comentario.getError("maxlength").requiredLength
                            }}
                            caracteres
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </mat-dialog-content>
    <mat-divider></mat-divider>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cancelar</button>

        <button
            mat-raised-button
            color="accent"
            [disabled]="!formInvitacion.valid"
            (click)="generarInvitacion()"
        >
            Invitar a cotizar
        </button>
    </mat-dialog-actions>
</div>
